import { render } from "./ImportColis.vue?vue&type=template&id=1e0007cc&scoped=true&ts=true"
import script from "./ImportColis.vue?vue&type=script&lang=ts"
export * from "./ImportColis.vue?vue&type=script&lang=ts"

import "./ImportColis.vue?vue&type=style&index=0&id=1e0007cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0007cc"]])

export default __exports__